import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root_2 = $.from_html(`<span class="svelte-19374oqn3cfkx"> </span>`);
var root_3 = $.from_html(`<button type="button"> </button>`);
var root_1 = $.from_html(`<div class="backdrop svelte-19374oqn3cfkx"></div> <div class="calendar svelte-19374oqn3cfkx"><div class="cal-head svelte-19374oqn3cfkx"><button type="button" class="nav-btn svelte-19374oqn3cfkx" aria-label="Previous month"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" class="svelte-19374oqn3cfkx"><path d="M15 18l-6-6 6-6"></path></svg></button> <span class="month-label svelte-19374oqn3cfkx"> </span> <button type="button" class="nav-btn svelte-19374oqn3cfkx" aria-label="Next month"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" class="svelte-19374oqn3cfkx"><path d="M9 18l6-6-6-6"></path></svg></button></div> <div class="weekdays svelte-19374oqn3cfkx"></div> <div class="days svelte-19374oqn3cfkx"></div> <div class="cal-foot svelte-19374oqn3cfkx"><button type="button" class="foot-btn svelte-19374oqn3cfkx">Clear</button> <button type="button" class="foot-btn accent svelte-19374oqn3cfkx">Today</button></div></div>`, 1);
var root = $.from_html(`<div class="date-picker svelte-19374oqn3cfkx"><button type="button"><svg class="cal-icon svelte-19374oqn3cfkx" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="4"></rect><path d="M16 2v4M8 2v4M3 10h18"></path></svg> <span> </span></button> <!></div>`);

function DatePicker($$anchor, $$props) {
	$.push($$props, true);

	// 'yyyy-mm-dd'
	let placeholder = $.prop($$props, 'placeholder', 3, 'Select date');

	let open = $.state(false);
	let triggerEl = $.state(void 0);
	let calStyle = $.state('');
	const today = new Date();

	const todayStr = [
		today.getFullYear(),
		String(today.getMonth() + 1).padStart(2, '0'),
		String(today.getDate()).padStart(2, '0')
	].join('-');

	let viewYear = $.state($.proxy($$props.value
		? parseInt($$props.value.split('-')[0])
		: today.getFullYear()));

	let viewMonth = $.state($.proxy($$props.value
		? parseInt($$props.value.split('-')[1]) - 1
		: today.getMonth()));

	const MONTH_NAMES = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];

	const WEEKDAYS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

	function buildCells(year, month) {
		const firstDow = (new Date(year, month, 1).getDay() + 6) % 7; // Mon = 0
		const daysInMonth = new Date(year, month + 1, 0).getDate();
		const prevMonthDays = new Date(year, month, 0).getDate();
		const cells = [];

		for (let i = firstDow - 1; i >= 0; i--) {
			cells.push({ day: prevMonthDays - i, dateStr: null, faded: true });
		}

		for (let d = 1; d <= daysInMonth; d++) {
			cells.push({
				day: d,
				dateStr: `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`,
				faded: false
			});
		}

		let next = 1;

		while (cells.length % 7 !== 0) {
			cells.push({ day: next++, dateStr: null, faded: true });
		}

		return cells;
	}

	const cells = $.derived(() => buildCells($.get(viewYear), $.get(viewMonth)));

	function prevMonth() {
		if ($.get(viewMonth) === 0) {
			$.set(viewMonth, 11);
			$.update(viewYear, -1);
		} else $.update(viewMonth, -1);
	}

	function nextMonth() {
		if ($.get(viewMonth) === 11) {
			$.set(viewMonth, 0);
			$.update(viewYear);
		} else $.update(viewMonth);
	}

	function select(dateStr) {
		$$props.onchange(dateStr);
		$.set(viewYear, parseInt(dateStr.split('-')[0]), true);
		$.set(viewMonth, parseInt(dateStr.split('-')[1]) - 1);
		$.set(open, false);
	}

	function formatDisplay(v) {
		if (!v) return '';

		const [y, m, d] = v.split('-');

		return `${d}/${m}/${y}`;
	}

	function openCalendar() {
		if (!$.get(triggerEl)) return;

		const rect = $.get(triggerEl).getBoundingClientRect();
		const calW = 288;
		let left = rect.left;

		if (left + calW > window.innerWidth - 8) left = window.innerWidth - calW - 8;
		if (left < 8) left = 8;

		// Flip upward if not enough space below
		const spaceBelow = window.innerHeight - rect.bottom;

		const calH = 340;
		const top = spaceBelow >= calH ? rect.bottom + 6 : rect.top - calH - 6;

		$.set(calStyle, `top:${top}px;left:${left}px`);
		$.set(open, true);
	}

	var div = root();
	var button = $.child(div);
	let classes;
	var span = $.sibling($.child(button), 2);
	let classes_1;
	var text = $.child(span, true);

	$.reset(span);
	$.reset(button);
	$.bind_this(button, ($$value) => $.set(triggerEl, $$value), () => $.get(triggerEl));

	var node = $.sibling(button, 2);

	{
		var consequent = ($$anchor) => {
			var fragment = root_1();
			var div_1 = $.first_child(fragment);
			var div_2 = $.sibling(div_1, 2);
			var div_3 = $.child(div_2);
			var button_1 = $.child(div_3);
			var span_1 = $.sibling(button_1, 2);
			var text_1 = $.child(span_1);

			$.reset(span_1);

			var button_2 = $.sibling(span_1, 2);

			$.reset(div_3);

			var div_4 = $.sibling(div_3, 2);

			$.each(div_4, 21, () => WEEKDAYS, $.index, ($$anchor, wd) => {
				var span_2 = root_2();
				var text_2 = $.child(span_2, true);

				$.reset(span_2);
				$.template_effect(() => $.set_text(text_2, $.get(wd)));
				$.append($$anchor, span_2);
			});

			$.reset(div_4);

			var div_5 = $.sibling(div_4, 2);

			$.each(div_5, 21, () => $.get(cells), $.index, ($$anchor, cell) => {
				var button_3 = root_3();
				let classes_2;
				var text_3 = $.child(button_3, true);

				$.reset(button_3);

				$.template_effect(() => {
					classes_2 = $.set_class(button_3, 1, 'day svelte-19374oqn3cfkx', null, classes_2, {
						faded: $.get(cell).faded,
						today: $.get(cell).dateStr === todayStr,
						selected: $.get(cell).dateStr === $$props.value
					});

					button_3.disabled = !$.get(cell).dateStr;
					$.set_text(text_3, $.get(cell).day);
				});

				$.delegated('click', button_3, () => $.get(cell).dateStr && select($.get(cell).dateStr));
				$.append($$anchor, button_3);
			});

			$.reset(div_5);

			var div_6 = $.sibling(div_5, 2);
			var button_4 = $.child(div_6);
			var button_5 = $.sibling(button_4, 2);

			$.reset(div_6);
			$.reset(div_2);

			$.template_effect(() => {
				$.set_style(div_2, $.get(calStyle));
				$.set_text(text_1, `${MONTH_NAMES[$.get(viewMonth)] ?? ''} ${$.get(viewYear) ?? ''}`);
			});

			$.delegated('click', div_1, () => $.set(open, false));
			$.delegated('click', div_2, (e) => e.stopPropagation());
			$.delegated('click', button_1, prevMonth);
			$.delegated('click', button_2, nextMonth);

			$.delegated('click', button_4, () => {
				$$props.onchange('');
				$.set(open, false);
			});

			$.delegated('click', button_5, () => select(todayStr));
			$.append($$anchor, fragment);
		};

		$.if(node, ($$render) => {
			if ($.get(open)) $$render(consequent);
		});
	}

	$.reset(div);

	$.template_effect(
		($0) => {
			$.set_attribute(button, 'id', $$props.id);
			classes = $.set_class(button, 1, 'trigger svelte-19374oqn3cfkx', null, classes, { open: $.get(open) });
			classes_1 = $.set_class(span, 1, 'svelte-19374oqn3cfkx', null, classes_1, { faded: !$$props.value });
			$.set_text(text, $0);
		},
		[
			() => $$props.value ? formatDisplay($$props.value) : placeholder()
		]
	);

	$.delegated('click', button, (e) => {
		e.stopPropagation();
		$.get(open) ? $.set(open, false) : openCalendar();
	});

	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	DatePicker = $.hmr(DatePicker);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-19374oqn3cfkx');
		DatePicker[$.HMR].update(module.default);
	});
}

export default DatePicker;

$.delegate(['click']);
import "bun-svelte:DatePicker.svelte-1f9692ue8x0kv-style.css";